export const formatErrorText = (error: any) => {
  const normalError = error.reason?.response?.data?.messages;
  const singleError = error.reason?.response?.data?.error?.message;
  const axiosError = error.response.data.messages;
  return normalError || singleError || axiosError || 'Unknown error';
};
